export enum OperationType {
  ThirdPartyAddon = 'ThirdPartyAddon',
  Addon = 'Addon',
  Upgrade = 'Upgrade',
  Renewal = 'Renewal'
}

export enum CountryIso2Code {
  US = 'US'
}

export enum Addons {
  CHASSocialSustainability = 'CHAS Social Sustainability',
  CHASVehicleComplianceScheme = 'CHAS Vehicle Compliance Scheme'
}
